import React, { useContext, useEffect } from 'react';
import classes from './ContactUsPage.module.css';
import ContactFormBlock from './ContactFormBlock/ContactFormBlock';
import { ThemeContext } from '../../App';

export default function ContactUsPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { theme } = useContext(ThemeContext);

  return (
    <>
      <div id={classes[theme]} className={classes.back} />
      <div className=" flex justify-center">
        <p className="w-9/12 lg:w-5/12 text-center py-10 sm:text-smAddTxt md:text-mdSepBtnTxt lg:text-lgSepBtn2Txt">
          To know about more about our consultants and how we can help your
          business, please mail us at <span>info@fptech-us.com</span> or send us
          your details in the form below:
        </p>
      </div>
      <ContactFormBlock />
    </>
  );
}
